import { PrincipalConfigurationEffects } from './principal-configuration.effect';

export const effects: any[] = [PrincipalConfigurationEffects];
